import './index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { Skeleton } from '@hh.ru/magritte-ui-skeleton';

const CardSkeleton = forwardRef(({ Component: Card, 
// skeleton props
width, height, 
// borderRadius остается в cardProps
inline, additionalClass, loading, ...cardProps }, ref) => {
    return (jsx(Skeleton, { width: cardProps.stretched ? `100%` : width, height: cardProps.verticalStretched ? `100%` : height, borderRadius: cardProps.borderRadius, borderTopLeftRadius: cardProps.borderTopLeftRadius, borderTopRightRadius: cardProps.borderTopRightRadius, borderBottomLeftRadius: cardProps.borderBottomLeftRadius, borderBottomRightRadius: cardProps.borderBottomRightRadius, loading: loading, children: jsx(Card, { ref: ref, ...cardProps }) }));
});
CardSkeleton.displayName = 'CardSkeleton';

export { CardSkeleton };
//# sourceMappingURL=Skeleton.js.map
